module.exports = __webpack_public_path__ + "static/Madeeha.aa28add5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/Madeeha.jpg
// module id = 1310
// module chunks = 137408898365125